import { render } from "./addRole.vue?vue&type=template&id=6c3eb712"
import script from "./addRole.vue?vue&type=script&lang=js"
export * from "./addRole.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__